module.exports = __webpack_public_path__ + "/login_ui/img/st-18d2a5b9f7941c11af468d02ba023f4e.svg";